import { Injectable } from '@angular/core';
import { ActionCompletion, Actions, ofActionCompleted, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { ConfirmationDialogAfterClosedModel } from '../../../../../ui-kit/confirmation-dialog';
import { PlantItemDelete } from './plant-item.actions';
import { PlantRequestModel } from '../models';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../common/models';
import { PlantItemCreate, PlantItemInitialState, PlantItemLoad, PlantItemUpdate } from './plant-item.actions';
import { PlantItemState, PlantItemStateModel } from './plant-item.state';
import { MatDialogRef } from '@angular/material/dialog';

@Injectable({ providedIn: 'root' })
export class PlantItemFacade implements LoadDataFacade, SetInitialStateFacade {
  plantData$: Observable<PlantItemStateModel> = this.store.select(PlantItemState.getState);
  plantId$: Observable<number> = this.store.select(PlantItemState.getPlantId);
  plantName$: Observable<string> = this.store.select(PlantItemState.getPlantName);
  loaded$: Observable<boolean> = this.store.select(PlantItemState.getLoaded);

  constructor(private store: Store, private actions: Actions) {}

  loadAll(partnerId: string): void {
    this.store.dispatch(new PlantItemLoad(partnerId));
  }

  createPlant(data: PlantRequestModel): void {
    this.store.dispatch(new PlantItemCreate(data));
  }

  updatePlant(data: PlantRequestModel): Observable<ActionCompletion<unknown, Error>> {
    this.store.dispatch(new PlantItemUpdate(data));
    return this.actions.pipe(ofActionCompleted(PlantItemUpdate));
  }

  deletePlant(plantId: number, dialog: MatDialogRef<ConfirmationDialogAfterClosedModel>): void {
    this.store.dispatch(new PlantItemDelete({ dialog, plantId }));
  }

  setInitialState(): void {
    this.store.dispatch(new PlantItemInitialState());
  }
}
